import React, { useState, useRef, useEffect } from 'react';
import { FaUser, FaSignOutAlt, FaChevronDown, FaHeadset } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'src/context/AuthContext';

const LogoutDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const { logout } = useAuth();

  const name = (localStorage.getItem("Name") || "User").replace(/^"|"$/g, '');
  const district = (localStorage.getItem("District") || "").replace(/^"|"$/g, '');
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setIsOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 p-1.5 rounded-full hover:bg-gray-100 transition-all border border-gray-200 text-primary group"
      >
        <div className="bg-primary/10 p-2 rounded-full group-hover:bg-primary/20 transition-colors">
          <FaUser size={18} />
        </div>
        <FaChevronDown size={12} className={`mr-1 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-3 w-72 bg-white rounded-xl shadow-2xl border border-gray-200 overflow-hidden text-gray-800 z-50">
          {/* Header - Still Primary for brand recognition */}
          <div className="p-5 bg-primary text-white">
            <p className="font-bold truncate text-base uppercase tracking-wide">{name}</p>
            {district && <p className="text-xs opacity-80 mt-1 font-medium"> District {district}</p>}
          </div>

          {/* Support Section */}
          <div className="p-4 border-b border-gray-100 bg-gray-50">
            <div className="flex items-center gap-2 text-[10px] font-bold text-gray-400 uppercase">
              <FaHeadset className="text-primary" /> Support 
               <a href="tel:+917814987433" className="text-primary">
              +91 7814987433
            </a>
            </div>
          </div>

          {/* Language Selector */}
          {/* <div className="p-4 border-b border-gray-100">
            <div className="flex items-center gap-2 text-[10px] font-bold text-gray-400 uppercase mb-3">
              <FaGlobe className="text-primary" /> Language
            </div>
            <div className="grid grid-cols-2 gap-2 p-1 bg-gray-100 rounded-lg">
              <button 
                onClick={() => i18n.changeLanguage('en')}
                className={`py-2 text-xs font-bold rounded-md transition-all ${i18n.language === 'en' ? 'bg-white shadow-sm text-primary' : 'text-gray-500 hover:text-gray-700'}`}
              >
                ENGLISH
              </button>
              <button 
                onClick={() => i18n.changeLanguage('hi')}
                className={`py-2 text-xs font-bold rounded-md transition-all ${i18n.language === 'hi' ? 'bg-white shadow-sm text-primary' : 'text-gray-500 hover:text-gray-700'}`}
              >
                हिन्दी
              </button>
            </div>
          </div> */}

          {/* Logout */}
          <button 
            onClick={() => {
              const role = logout();
              navigate(role === "mcc" ? "/mcc" : role === "admin" ? "/admin" : "/");
            }}
            className="w-full flex items-center justify-center gap-3 py-4 text-sm text-red-600 hover:bg-red-50 transition-colors font-bold uppercase"
          >
            <FaSignOutAlt /> Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default LogoutDropdown;